import React from 'react';
import { SelectField } from '@bucketplace/commerce-admin-ui';

import { FormContent, InspectorFormProvider } from '../../components';
import { DocumentInspectorProps } from '../../types';
import { TabProps } from './Tab';

const BUTTON_COLUMN_OPTIONS = [
  { text: '2', value: 2 },
  { text: '3', value: 3 },
  { text: '4', value: 4 },
  { text: '5', value: 5 },
];

export function TabInspector({
  value,
  onChange,
}: DocumentInspectorProps<TabProps>) {
  return (
    <InspectorFormProvider value={value} onChange={onChange}>
      <FormContent header="버튼 열">
        <SelectField
          name="buttonColumn"
          width="100%"
          options={BUTTON_COLUMN_OPTIONS}
        />
      </FormContent>
    </InspectorFormProvider>
  );
}
